// First-touch attribution helpers shared by the page tracker and the quote save calls.
const SID_KEY = "de_sid";
const ATTR_KEY = "de_attr";

export function getSessionId() {
  let sid = localStorage.getItem(SID_KEY);
  if (!sid) {
    sid = (window.crypto && window.crypto.randomUUID)
      ? window.crypto.randomUUID()
      : `s-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(SID_KEY, sid);
  }
  return sid;
}

// Captured once per browser session (referrer + UTMs + landing page).
export function getAttribution() {
  const existing = sessionStorage.getItem(ATTR_KEY);
  if (existing) {
    try { return JSON.parse(existing); } catch { /* fallthrough */ }
  }
  const params = new URLSearchParams(window.location.search);
  const attr = {
    referrer: document.referrer || "",
    utm_source: params.get("utm_source") || "",
    utm_medium: params.get("utm_medium") || "",
    utm_campaign: params.get("utm_campaign") || "",
    landing_path: window.location.pathname || "/",
  };
  sessionStorage.setItem(ATTR_KEY, JSON.stringify(attr));
  return attr;
}

// Spread into quote-save payloads so the backend can stamp `lead_source` on the quote.
export function leadAttribution() {
  try {
    return { session_id: getSessionId(), attribution: getAttribution() };
  } catch {
    return {};
  }
}
